import { z } from "zod";
import { actionAvailabilitySchema } from "@amber/contracts";
import { DELETED_TABS, archiveSummarySchema, deletedRowSchema } from "@amber/collection/contracts";

export const deletedResponseSchema = z.strictObject({
  tab: z.enum(DELETED_TABS),
  counts: z.strictObject({ deleted: z.number().int().nonnegative(), restricted: z.number().int().nonnegative() }),
  rows: z.array(deletedRowSchema).nullable(),
  archive: archiveSummarySchema,
  restore: actionAvailabilitySchema,
  policy_version: z.string(),
});
export type DeletedResponse = z.infer<typeof deletedResponseSchema>;
